const { BinaryToGUID } = require('mongo-binary-parser')
const uuid = require('uuid')

class EntityRoot {
  constructor(document) {
    let id = document._id || document.id
    if (!id || !id.toString().length) {
      id = uuid.v4()
    }

    this._id = BinaryToGUID(id)
    this.id = this._id
    this.IsEnabled = typeof document.IsEnabled === 'undefined' ? true : document.IsEnabled
    this.ExtraElements = document.ExtraElements
  }
}

module.exports = EntityRoot
